(() => {
  'use strict';
  const cleanups = new WeakMap();
  function initialize(root) {
    if (cleanups.has(root)) return;
    const body = root.querySelector('[data-ce-body]');
    const toc = root.querySelector('[data-ce-toc]');
    const list = root.querySelector('[data-ce-toc-list]');
    const headings = [...body.querySelectorAll('h2')];
    if (!headings.length) return;
    // Reserve every ID before generating any, including IDs on later headings.
    const counts = new Map();
    document.querySelectorAll('[id]').forEach(el => counts.set(el.id, (counts.get(el.id) || 0) + 1));
    const used = new Set(counts.keys());
    headings.forEach((heading, index) => {
      if (!heading.id || counts.get(heading.id) !== 1) {
        const slug = heading.textContent.trim().normalize('NFKD').toLowerCase().replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        let candidate = slug, suffix = 2;
        while (used.has(candidate)) candidate = `${slug}-${suffix++}`;
        heading.id = candidate;
        used.add(candidate);
      }
      heading.setAttribute('tabindex', '-1');
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      // Empty headings have a nonempty navigation label without changing article HTML.
      link.textContent = heading.textContent.trim() || `${toc.querySelector('summary').textContent} ${index + 1}`;
      item.append(link); list.append(item);
    });
    root.querySelector('[data-ce-left]').hidden = false;
    toc.hidden = false;
    const wide = matchMedia('(min-width: 1200px)');
    const layout = () => { toc.open = wide.matches; };
    layout(); wide.addEventListener('change', layout);
    const headers = [...document.querySelectorAll('sticky-header, .shopify-section-header, .s-header, .s-announcement, header[role="banner"]')];
    let offset = 24;
    let measureFrame = 0;
    const measure = () => {
      let headerBottom = 0;
      headers.forEach(el => {
        const style = getComputedStyle(el), rect = el.getBoundingClientRect();
        if ((style.position === 'sticky' || style.position === 'fixed') && rect.height && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
      });
      // The desktop sidebar gap affects sticky positioning and available TOC height only.
      const stickyTop = headerBottom + (wide.matches ? 30 : 0);
      root.style.setProperty('--ce-sticky-top', `${stickyTop}px`);
      offset = headerBottom + 24 + (wide.matches ? 0 : toc.querySelector('summary').getBoundingClientRect().height);
      root.style.setProperty('--ce-anchor-offset', `${offset}px`);
    };
    measure();
    const followHash = () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const target = headings.find(h => h.id === id);
      if (!target) return;
      if (!wide.matches) toc.open = false;
      measure();
      target.focus({preventScroll: true});
      target.scrollIntoView({block: 'start', behavior: 'instant'});
      list.querySelectorAll('a').forEach(a => {
        if (a.hash === `#${encodeURIComponent(id)}`) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
    };
    const click = event => {
      const link = event.target.closest('a');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      measure();
      if (link.hash === location.hash) requestAnimationFrame(followHash);
    };
    list.addEventListener('click', click);
    window.addEventListener('hashchange', followHash);
    window.addEventListener('resize', measure, {passive: true});
    const onScroll = () => {
      if (!measureFrame) measureFrame = requestAnimationFrame(() => { measureFrame = 0; measure(); });
    };
    window.addEventListener('scroll', onScroll, {passive: true});
    const resize = new ResizeObserver(measure); headers.forEach(h => resize.observe(h));
    requestAnimationFrame(followHash);
    const loaded = () => { if (location.hash) followHash(); };
    window.addEventListener('load', loaded, {once: true});
    cleanups.set(root, () => {
      wide.removeEventListener('change', layout); resize.disconnect();
      window.removeEventListener('hashchange', followHash); window.removeEventListener('resize', measure); window.removeEventListener('load', loaded);
      window.removeEventListener('scroll', onScroll); cancelAnimationFrame(measureFrame);
      list.removeEventListener('click', click); cleanups.delete(root);
    });
  }
  const start = scope => scope.querySelectorAll('[data-ce-article]').forEach(initialize);
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ce-article]').forEach(root => cleanups.get(root)?.()));
})();
